export default __webpack_public_path__ + "static/media/menu_scenarios_selected.1f119237.svg";